import axios from "axios";

export const state = {
    chartsofaccounts: [],
};

export const getters = {
    chartsofaccounts: state => state.chartsofaccounts,
};

export const mutations = {
    setChartsOfAccounts(state, newValue) {
        state.chartsofaccounts = newValue
    },
};

export const actions = {
    fetchChartsOfAccounts({ commit }) {
        axios.get('/chartsofaccounts').then(res => {
            commit('setChartsOfAccounts', res.data.accounts)
        })
    },
};
